<div class="navbar-area" [class.scrolled]="isScrolled">
    <div class="main-responsive-nav">
        <div class="container">
            <div class="main-responsive-menu d-flex justify-content-between align-items-center">
                <div class="logo">
                   
                    <img [routerLink]="['/aboutus']" src="assets/images/cxo-logo.svg" class="black-logo pointer" alt="image" />
                </div>
                <div class="menu-toggle" (click)="toggleMenu()">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    </div>

    <div class="main-navbar">
        <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">

                <a class="navbar-brand">
                    <img [routerLink]="['/aboutus']" src="assets/images/cxo-logo.svg" class="black-logo pointer" alt="image" >
                </a>

                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav menu_right">
                        <li class="nav-item">
                            <a class="nav-link " [class.active]="activeSection === 'aboutus'"
                                (click)="scrollToSection('aboutus')">
                                About Us
                            </a>
                        </li>

                        <!-- <li class="nav-item">
                            <a class="nav-link" [class.active]="activeSection === 'aboutus'"
                                (click)="scrollToSection('aboutus')">About Us</a>
                        </li> -->
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeSection === 'membership'"
                                (click)="scrollToSection('membership')">Membership</a>
                        </li>
                        
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeSection === 'sponsors'"
                                (click)="scrollToSection('sponsors')">
                                Sponsors
                            </a>
                        </li>

                        <!-- <li class="nav-item">
                            <a class="nav-link" [class.active]="activeSection === 'contactus'"
                                (click)="scrollToSection('contactus')">Contact Us</a>
                        </li> -->
                    </ul>

                    <div class="others-options d-flex align-items-center ms-4">
                        <div class="option-item">
                            <a class="default-btn" (click)="scrollToSection('services')"> Upcoming
                                Events<span></span></a>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </div>

</div>
